import moment from "moment";

const getDueTime = (timeValue, typeValue) => {
 
    const formattedDateTime = moment(timeValue).format('YYYY-MM-DD HH:mm:ss');

    const newDateTime = moment(formattedDateTime).add(typeValue, 'hours').format('YYYY-MM-DD HH:mm:ss');
 

    return newDateTime;
}



const getDateTime = (timeValue) => {
       
    const startDate = new Date(timeValue).toLocaleDateString();
    const startTimeString = new Date(timeValue).toLocaleTimeString(undefined, { hour12: true });

    const dateTimeString = `${startDate} ${startTimeString}`;

    return dateTimeString;
}




export const GetDueDateTemp = (values) => {
    try {
        let dateValue = values.date;
        
            if (values.priority === 'Rush') {
                dateValue = getDateTime(getDueTime(parseInt(values.date), 2))
            } else if (values.priority === 'On Demand') {
             
                dateValue = getDateTime(getDueTime(parseInt(values.date), 24));
               
            } else if (values.priority === 'Bulk') {
                dateValue = getDateTime(getDueTime(parseInt(values.date), 48));

            }
        

        return dateValue;
    }
    catch (error) {
       
    }
}

export const checkDueStatus=(dueDateStr, completedDateStr)=> {
    if (!completedDateStr) {
      return "pending";
    }
    const dueDate = Number(dueDateStr);
    const completedDate = Number(completedDateStr);
  
    if (isNaN(dueDate) || isNaN(completedDate)) {
      return "invalid date";
    }
    return completedDate > dueDate ? "Failed" : "Success";
  }
  
  